// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__w03-O","borderless":"style_borderless__3pEYr","transparent":"style_transparent__1-JMj","error":"style_error__tdIFi","overflow":"style_overflow__23PAJ"};